import { render } from "./TenantManagement.vue?vue&type=template&id=458296c0&scoped=true"
import script from "./TenantManagement.vue?vue&type=script&lang=js"
export * from "./TenantManagement.vue?vue&type=script&lang=js"

import "./TenantManagement.vue?vue&type=style&index=0&id=458296c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458296c0"]])

export default __exports__